module.exports = __webpack_public_path__ + "img/de.7f3d5029.svg";